/*----------CART LOGIC START----------*/

const freebiePool = {
  // Uncomment when ready
  /*"mg_asl": { productVariantId: "42565516197966", weight: 2 },
  "mg_wm": { productVariantId: "42566584860750", weight: 6 },
  "mg_ms": { productVariantId: "42564535386190", weight: 4 }*/
};

const cartPromotions = {
  "scFreeLite": { conditionProductVariantId: "43179220500558", conditionProductQuantity: 2, freebieProductVariantId: "39909690376270", freebieProductQuantity: 1, freebieLimited: true },
  "lcsvip2x": { conditionProductVariantId: "43637114306638", conditionProductQuantity: 1, freebieProductVariantId: "40424482897998", freebieProductQuantity: 1, freebieLimited: true },
  "lcsvip3x1": { conditionProductVariantId: "43637114994766", conditionProductQuantity: 1, freebieProductVariantId: "40424482897998", freebieProductQuantity: 1, freebieLimited: true },
  "lcsvip3x2": { conditionProductVariantId: "43637114994766", conditionProductQuantity: 1, freebieProductVariantId: "39884299468878", freebieProductQuantity: 1, freebieLimited: true },
  "lcsvip5x1": { conditionProductVariantId: "43637116239950", conditionProductQuantity: 1, freebieProductVariantId: "40424482897998", freebieProductQuantity: 1, freebieLimited: true },
  "lcsvip5x2": { conditionProductVariantId: "43637116239950", conditionProductQuantity: 1, freebieProductVariantId: "42265178308686", freebieProductQuantity: 1, freebieLimited: true },
  "vip2x": { conditionProductVariantId: "44085996912718", conditionProductQuantity: 1, freebieProductVariantId: "39909690376270", freebieProductQuantity: 1, freebieLimited: true },
  "vip3x1": { conditionProductVariantId: "44086021455950", conditionProductQuantity: 1, freebieProductVariantId: "39909690376270", freebieProductQuantity: 1, freebieLimited: true },
  "vip3x2": { conditionProductVariantId: "44086021455950", conditionProductQuantity: 1, freebieProductVariantId: "39884299468878", freebieProductQuantity: 1, freebieLimited: true },
  "vip5x1": { conditionProductVariantId: "44086046294094", conditionProductQuantity: 1, freebieProductVariantId: "39909690376270", freebieProductQuantity: 1, freebieLimited: true },
  "vip5x2": { conditionProductVariantId: "44086046294094", conditionProductQuantity: 1, freebieProductVariantId: "42265178308686", freebieProductQuantity: 1, freebieLimited: true },
  /*"as9freemainsh": { conditionProductVariantId: "39811906994254", conditionProductQuantity: 2, freebieProductVariantId: "39992219598926", freebieProductQuantity: 1, freebieLimited: true },*/
  "lcsvip2xbogo": { conditionProductVariantId: "43194584563790", conditionProductQuantity: 1, freebieProductVariantId: "40424482897998", freebieProductQuantity: 1, freebieLimited: true },
  "lcsvip3xbogo1": { conditionProductVariantId: "43194588594254", conditionProductQuantity: 1, freebieProductVariantId: "40424482897998", freebieProductQuantity: 1, freebieLimited: true },
  "lcsvip3xbogo2": { conditionProductVariantId: "43194588594254", conditionProductQuantity: 1, freebieProductVariantId: "41351949516878", freebieProductQuantity: 1, freebieLimited: true },
  "flashbonuscoatings": { conditionProductVariantId: ["39811906994254", "40287735414862", "40227921657934", "43854151614542"], conditionProductQuantity: 1, freebieProductVariantId: "39992219598926", freebieProductQuantity: 1, freebieLimited: true }
};

// 1. Intercept network requests to detect ANY cart changes
const originalFetch = window.fetch;
window.fetch = function() {
  return originalFetch.apply(this, arguments).then((response) => {
    const url = response.url || arguments[0];
    if (url && (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update') || url.includes('/cart/clear'))) {
      response.clone().json().then(data => {
        document.dispatchEvent(new CustomEvent('my:global:cart:update', { detail: data }));
      }).catch(err => console.error(err));
    }
    return response;
  });
};

// 2. Listen for the global update and check freebies
let isCartFreebieSyncRunning = false;
let cartFreebieSyncQueued = false;

function queueCartFreebieSync() {
  cartFreebieSyncQueued = true;
  if (!isCartFreebieSyncRunning) {
    runCartFreebieSync().catch(error => console.error('Cart Freebie Sync Error:', error));
  }
}

document.addEventListener('my:global:cart:update', queueCartFreebieSync);

// --- HELPER FUNCTIONS ---

// Reusable function to trigger Combine's native cart refresh
function refreshCombineCart() {
  if (typeof window.refreshCart === 'function') window.refreshCart();
  const drawer = document.querySelector('cart-drawer, sidebar-drawer[id*="cart"]');
  if (drawer && typeof drawer.open === 'function') {
    drawer.open();
  } else {
    document.querySelector('a[href="/cart"]')?.click();
  }
}

// Reusable function to handle the fetch request and refresh
async function updateCart(endpoint, payload) {
  try {
    const res = await fetch(window.Shopify.routes.root + endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });
    await res.json();
    refreshCombineCart();
    return true;
  } catch (error) {
    console.error('Cart Update Error:', error);
    return false;
  }
}

// --- MAIN LOGIC ---

async function runCartFreebieSync() {
  isCartFreebieSyncRunning = true;

  try {
    while (cartFreebieSyncQueued) {
      cartFreebieSyncQueued = false;
      const didMutateCart = await checkCartForCodeFreebie();

      // Always re-check after a successful mutation using a fresh cart snapshot.
      if (didMutateCart) {
        cartFreebieSyncQueued = true;
      }
    }
  } finally {
    isCartFreebieSyncRunning = false;
  }
}

async function checkCartForCodeFreebie() {
  // Use native fetch instead of jQuery
  const cart = await fetch('/cart.js').then(res => res.json());
  const cartItems = cart.items;

  for (const key in cartPromotions) {
    const promo = cartPromotions[key];
    
    // 1. Find condition items in cart (exclude freebies)
    // conditionProductVariantId can be a single ID or an array of IDs (any of them qualifies)
    const conditionIds = [].concat(promo.conditionProductVariantId).map(String);
    const conditionItems = cartItems.filter(e => conditionIds.includes(String(e.variant_id)) && !e.properties?._cart_campaign);
    const conditionQty = conditionItems.reduce((total, item) => total + item.quantity, 0);

    // 2. Calculate how many freebies the customer deserves
    let targetQty = 0;
    if (conditionQty >= promo.conditionProductQuantity) {
      targetQty = promo.freebieLimited 
        ? promo.freebieProductQuantity 
        : Math.floor(conditionQty / promo.conditionProductQuantity) * promo.freebieProductQuantity;
    }

    // 3. Find existing freebies for this campaign in the cart
    const existingFreebies = key === "cart_campaign_pool"
      ? cartItems.filter(e => e.properties?._cart_campaign === "cart_campaign_pool")
      : cartItems.filter(e => e.variant_id == promo.freebieProductVariantId && e.properties?._cart_campaign === key);

    // 4. Determine Freebie ID (Randomize only if pool and not already in cart)
    let freebieId = promo.freebieProductVariantId; 
    if (key === "cart_campaign_pool" && targetQty > 0 && existingFreebies.length === 0) {
      const poolArray = [];
      for (const pKey in freebiePool) {
        for (let i = 0; i < freebiePool[pKey].weight; i++) poolArray.push(freebiePool[pKey].productVariantId);
      }
      if (poolArray.length > 0) freebieId = poolArray[Math.floor(Math.random() * poolArray.length)];
    }

    // 5. Apply one change at a time, then re-check with a fresh cart snapshot.
    if (existingFreebies.length > 0) {
      // Freebie exists, check if quantity needs updating/removing
      if (existingFreebies[0].quantity !== targetQty) {
        return updateCart('cart/change.js', { 
          id: existingFreebies[0].key, 
          quantity: targetQty 
        });
      }
    } else if (targetQty > 0 && freebieId) {
      // Freebie doesn't exist, add it
      return updateCart('cart/add.js', {
        items: [{
          id: freebieId,
          quantity: targetQty,
          properties: { '_cart_campaign': key, '_dynamicfreebie': true }
        }]
      });
    }
  } // end loop

  return false;
}
/*----------CART LOGIC END----------*/